import API from './base';
import { getToken } from '../helpers';
import { getUrlToApi } from '../constants/api';

export default class InquiryStatusApi extends API {
  getInquiryStatus(ogrn = '') {
    return this.get(getUrlToApi(`disclosure/access/requests/${ogrn}`), getToken(), false);
  }
}
